module.exports = __webpack_public_path__ + "static/media/Chance The Rapper - Israel ft. Noname Gypsy.0af2b79e.mp3";